/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerNaturalPersonDto } from './BorrowerNaturalPersonDto';
import {
    BorrowerNaturalPersonDtoFromJSON,
    BorrowerNaturalPersonDtoFromJSONTyped,
    BorrowerNaturalPersonDtoToJSON,
    BorrowerNaturalPersonDtoToJSONTyped,
} from './BorrowerNaturalPersonDto';

/**
 * Individual insured person information
 * @export
 * @interface BorrowerDto
 */
export interface BorrowerDto {
    /**
     * Insurance contract identifier
     * @type {string}
     * @memberof BorrowerDto
     */
    borrowerId: string;
    /**
     * 
     * @type {BorrowerNaturalPersonDto}
     * @memberof BorrowerDto
     */
    person: BorrowerNaturalPersonDto;
}

/**
 * Check if a given object implements the BorrowerDto interface.
 */
export function instanceOfBorrowerDto(value: object): value is BorrowerDto {
    if (!('borrowerId' in value) || value['borrowerId'] === undefined) return false;
    if (!('person' in value) || value['person'] === undefined) return false;
    return true;
}

export function BorrowerDtoFromJSON(json: any): BorrowerDto {
    return BorrowerDtoFromJSONTyped(json, false);
}

export function BorrowerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'borrowerId': json['borrowerId'],
        'person': BorrowerNaturalPersonDtoFromJSON(json['person']),
    };
}

export function BorrowerDtoToJSON(json: any): BorrowerDto {
    return BorrowerDtoToJSONTyped(json, false);
}

export function BorrowerDtoToJSONTyped(value?: BorrowerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'borrowerId': value['borrowerId'],
        'person': BorrowerNaturalPersonDtoToJSON(value['person']),
    };
}

